import * as React from 'react';

function Shooting(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 16.5a.75.75 0 01.745.663l.005.088v3l-.005.088a.75.75 0 01-1.49 0l-.005-.088v-3l.005-.088A.75.75 0 0112 16.5zm7.35-2.999a7.51 7.51 0 01-5.85 5.85v-1.54a6.012 6.012 0 004.311-4.31h1.54zm-13.162 0a6.011 6.011 0 004.312 4.31v1.54a7.51 7.51 0 01-5.85-5.85h1.538zM12 9.751a.75.75 0 01.745.662l.005.087v.75h.75l.088.006a.75.75 0 010 1.49l-.088.005h-.75v.75l-.005.087a.75.75 0 01-1.49 0l-.005-.087v-.751h-.75l-.088-.005a.75.75 0 010-1.49l.088-.005h.75v-.75l.005-.087A.75.75 0 0112 9.75zm-8.25 1.5h3l.087.005a.75.75 0 010 1.49l-.087.005h-3l-.089-.006a.75.75 0 01.088-1.495zm13.5 0h3l.088.005a.75.75 0 010 1.49l-.087.005h-3l-.088-.006a.75.75 0 01.087-1.495zm-6.75-6.6v1.538a6.011 6.011 0 00-4.312 4.312L4.65 10.5a7.51 7.51 0 015.85-5.85zm3 0a7.51 7.51 0 015.85 5.85h-1.539a6.01 6.01 0 00-4.31-4.312V4.65zM12 3a.75.75 0 01.745.662l.005.088v3l-.005.088a.75.75 0 01-1.49 0l-.005-.088v-3l.005-.088A.75.75 0 0112 3z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Shooting;
